// Export the enhanced version with loading states and better UX
export { default } from './AddressSearchEnhanced';
export { default as AddressSearchOriginal } from './AddressSearch';
export { default as AddressSearchEnhanced } from './AddressSearchEnhanced';
export { ADDRESS_INPUT_ID } from './AddressSearchEnhanced';